import Row from '@components/Row';
import Text from '@components/Text';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

import RadioCircle from './RadioCircle';

interface Props {
    value: string;
    children?: ReactNode;
    isSelected?: boolean;
    onChange?: (v: string) => void;
    disabled?: boolean;
}

function Radio({
    value, children, isSelected, onChange, disabled,
}: Props) {
    return (<Container fullWidth
        data-selected={isSelected}
        justify='space-between'
        align='center'
        aria-disabled={disabled}
        onClick={() => {
            if (!disabled) {
                onChange?.(value);
            }
        }} >
        <Row spacing={1.5} fullWidth>
            <RadioCircle isSelected={isSelected} />
            <Text as='div' css={childrenCss}>{children}</Text>
        </Row>
    </Container>);
}

const Container = styled(Row)`
    cursor: pointer;

    &[aria-disabled="true"] {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

const childrenCss = css`
    width: 100%;
`;

export default Radio;
